import React from 'react'

import classNames from 'classnames'

import { formatSurcharge } from '../../../../utils/formatSurcharge'

import css from './Surcharge.css'

type SurchargeProps = {
  surcharge: number
}

export const Surcharge = ({ surcharge }: SurchargeProps) => {
  if (!surcharge) {
    return null
  }

  return (
    <div className={classNames(css.surcharge, { [css.valueBackground]: surcharge < 0 })}>
      {formatSurcharge(surcharge)} per serving
    </div>
  )
}
